import { render, staticRenderFns } from "./imgPlaceholder.vue?vue&type=template&id=83345a4c&"
import script from "./imgPlaceholder.vue?vue&type=script&lang=js&"
export * from "./imgPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./imgPlaceholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports